import { useEffect, useState } from "react";
import { Users, Pencil, Plus, Trash2, Search } from "lucide-react";
import { toast } from "sonner";
import { api, money } from "../api";
import { useAuth } from "../auth";
import EntityEditModal from "../components/EntityEditModal";
import SubcontractorDetail from "./SubcontractorDetail";

export default function Subcontractors() {
  const { can } = useAuth();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [modal, setModal] = useState(null);
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/subcontractors").then(r => setItems(r.data)).catch(() => toast.error("Alt yükleniciler yüklenemedi"));
  useEffect(() => { load(); }, []);
  const remove = async (id) => { if (window.confirm("Silinsin mi?")) { await api.delete(`/subcontractors/${id}`); load(); } };

  const filtered = items.filter(s => !q || s.short_name?.toLowerCase().includes(q.toLowerCase()) || s.name?.toLowerCase().includes(q.toLowerCase()));

  if (selected) return <SubcontractorDetail id={selected} onBack={() => { setSelected(null); load(); }} />;

  return (
    <main className="content" data-testid="page-subcontractors">
      <div className="page-head">
        <div>
          <span className="section-kicker">ALT YÜKLENİCİ AĞI</span>
          <h1>Alt Yükleniciler ({items.length})</h1>
          <p>Karta tıklayın: tüm işleri, ödeme dökümleri ve kalan bakiye. Fatura/şirket detaylarını kalem simgesinden girebilirsiniz.</p>
        </div>
        {can("admin", "project_manager") && <button className="new-btn" onClick={() => setModal({})} data-testid="toggle-sub-form"><Plus size={17} /> Yeni Alt Yüklenici</button>}
      </div>

      <div className="filter-bar">
        <div className="search-wrap"><Search size={15} /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Alt yüklenici ara..." data-testid="sub-search" /></div>
      </div>

      <div className="card-grid" data-testid="sub-cards">
        {filtered.map((s) => (
          <div className="entity-card clickable" key={s.id} data-testid={`sub-card-${s.short_name}`} onClick={() => setSelected(s.id)}>
            <div className="entity-head">
              <div className="entity-badge blue"><Users size={16} /></div>
              <div><b>{s.short_name}</b><small>{s.name}</small></div>
              <div className="row-actions" onClick={(e) => e.stopPropagation()}>
                <button className="row-action" onClick={() => setModal(s)} data-testid={`edit-sub-${s.short_name}`}><Pencil size={13} /></button>
                {can("admin", "project_manager") && <button className="row-action danger" onClick={() => remove(s.id)} data-testid={`delete-sub-${s.short_name}`}><Trash2 size={13} /></button>}
              </div>
            </div>
            <div className="entity-stats">
              <span><small>PROJE</small><b>{s.assigned_projects || 0}</b></span>
              <span><small>SÖZLEŞME</small><b>{money(s.contract_total)}</b></span>
              <span><small>KALAN</small><b>{money(s.remaining)}</b></span>
            </div>
            <div className="entity-meta">
              {s.specialty && <span>Uzmanlık: {s.specialty}</span>}
              {s.tax_no ? <span>Vergi: {s.tax_office || "—"} · {s.tax_no}</span> : <span className="missing">Fatura bilgisi eksik</span>}
              {s.iban && <span className="mono-small">{s.iban}</span>}
            </div>
          </div>
        ))}
        {!filtered.length && <div className="empty-hint">Alt yüklenici bulunamadı.</div>}
      </div>
      {modal && <EntityEditModal kind="subcontractor" item={modal.id ? modal : null} close={() => setModal(null)} onSaved={load} />}
    </main>
  );
}
